import { sum } from 'lodash'

import { MAX_IMAGE_SIZE_BYTE, MAX_TOTAL_IMAGE_SIZE_BYTE } from 'config'
import { getDeviceId } from 'lib/user'

export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.toString())
    reader.onerror = (error) => reject(error)
  })
}

export const getImageAttributeFromFile = (
  file: File
): Promise<HTMLImageElement> => {
  return new Promise(async (resolve, reject) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)

    img.onload = () => {
      URL.revokeObjectURL(objectUrl) // Clean up the object URL
      resolve(img)
    }

    img.onerror = (error) => {
      URL.revokeObjectURL(objectUrl)
      reject(error)
    }

    img.src = objectUrl
  })
}

export const checkFileSize = (file: File) => file.size <= MAX_IMAGE_SIZE_BYTE

export const checkTotalFileSize = (files: File[]) => {
  const totalFileSize = sum(files.map((f) => f.size))

  return totalFileSize <= MAX_TOTAL_IMAGE_SIZE_BYTE
}

export const getBase64FromURL = (url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onerror = (error) => reject(error)
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.naturalWidth
      canvas.height = img.naturalHeight

      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)

      const dataURL = canvas.toDataURL('image/png')

      resolve(dataURL)
    }
    img.src = url
  })
}

export const getFileFromURL = async (
  url: string,
  name?: string
): Promise<File> => {
  const source = url.startsWith('/') ? url : await getBase64FromURL(url)
  const response = await fetch(source)
  const blob = await response.blob()
  const file = await new File(
    [blob],
    name ?? `${getDeviceId()}-${Date.now()}.${blob.type.split('/').pop()}`,
    {
      type: blob.type,
    }
  )

  return file
}

export const PLACEHOLDER_PROFILE_IMAGE = '/images/placeholder-profile.svg'

// This is just a 1 pixel blue image.
export const PLACEHOLDER_GROUP_COVER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkyHz6HwAEDgJPnnYcJQAAAABJRU5ErkJggg=='

// This is just a 1 pixel gray image.
export const PLACEHOLDER_USER_COVER_IMAGE =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8+h8AAs8B5qzsEekAAAAASUVORK5CYII='
